import React from 'react';
import { FundamentalInfoService } from 'application/services';
import { styled } from '@mui/material';
import { generatePath } from 'react-router';
import { routes } from 'main/router';
import { Mixpanel } from 'infra/mixpanel';

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
  // paddingTop: '1rem'
  // borderTop: '1px solid #00002F26',
});

const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  paddingBottom: '0.5rem',
  fontSize: '0.75rem',
  color: '#000000',
  fontWeight: 700
});

const TableWrapper = styled('div')({
  width: '100%',

  '& > table': {
    background: '#FFFFFF',
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
    fontSize: '0.75rem',

    '& thead': {
      '& tr th': {
        fontWeight: 400
      }
    },

    '& tr': {
      border: '1px solid #0000001F',
      borderLeft: 0,
      borderRight: 0,

      '& th, & td': {
        textAlign: 'right',
        padding: '0.5rem 1rem',
        color: '#000000DE',

        '&:first-of-type': {
          textAlign: 'left',
          wordBreak: 'break-word',
          background: '#F5F5F5'
        },
        '&:last-of-type': {
          paddingLeft: 0
        }
      },

      '& td': {
        '&.value': {
          minWidth: 'fit-content',
          whiteSpace: 'nowrap'
        },

        '& a': {
          color: '#000000DE'
        }
      }
    }
  }
});

const TableRow = styled('tr')<{ selected?: boolean }>(({ selected }) => ({
  background: selected ? '#2196F314' : '#FFFFFF',
  outline: selected ? '1px solid #2196F380' : 'none',

  '& td, & a': {
    fontWeight: selected ? 700 : 400
  }
}));

const Badge = styled('span')({
  padding: '3px 6px',
  background: '#757575',
  color: '#FFFFFF',
  borderRadius: '4px',
  fontSize: '0.625rem',
  marginLeft: '0.25rem'
});

type Props = {
  referenceFundamental: FundamentalInfoService.Fundamental;
  restatedFundamentals: FundamentalInfoService.Fundamental[];
};

export const RestatementsTable = ({ referenceFundamental, restatedFundamentals }: Props) => {
  const handleFundamentalClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    Mixpanel.track('marketplace:src:restatement:click', { fundamentalId: event.currentTarget.id });
  };

  return (
    <Container>
      <Header>Datapoint Restatements</Header>
      <TableWrapper>
        <table>
          <thead>
            <tr>
              <th>Period</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {restatedFundamentals?.map(({ id, period, value }, index) => (
              <TableRow key={index}>
                <td>{period}</td>
                <td className="value">
                  <a
                    id={id}
                    href={generatePath(routes.SOURCE, { id })}
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleFundamentalClick}
                  >
                    {value}
                  </a>
                </td>
              </TableRow>
            ))}
            <tr>
              <td>
                {referenceFundamental.period}
                <Badge>Original</Badge>
              </td>
              <td>
                <a
                  id={referenceFundamental.id}
                  href={generatePath(routes.SOURCE, { id: referenceFundamental.id })}
                  target="_blank"
                  rel="noreferrer"
                  onClick={handleFundamentalClick}
                >
                  {referenceFundamental.value}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </TableWrapper>
    </Container>
  );
};
